import { style } from '@vanilla-extract/css';
import { nToPx, themeVars, toBorder } from '@tundr/theme';

export const infoListItemClass = style({
  display: 'flex',
  justifyContent: 'space-between',
  gap: themeVars.space.x6,
  padding: nToPx(themeVars.space.x2, themeVars.space.x4),
  borderBottom: toBorder(themeVars.colors.neutrals.grey40),
  fontSize: themeVars.font.size.textMd,

  selectors: {
    '&:last-child': {
      borderBottom: 'none',
    },
  },
});

export const withHoverClass = style({
  selectors: {
    '&:hover': {
      transition: themeVars.transitions.default,
      backgroundColor: themeVars.colors.neutrals.grey30,
    },
  },
});

export const itemLabelClass = style({
  flex: 2,
  fontWeight: themeVars.font.weight.bold,
});

export const itemValueClass = style({
  flex: 3,
  textAlign: 'justify',
  fontSize: themeVars.font.size.textSm,
  whiteSpaceCollapse: 'preserve',
});

export const wideSpacingClass = style({
  padding: nToPx(themeVars.space.x6, themeVars.space.x4),
});

export const compactSpacingClass = style({
  padding: nToPx(themeVars.space.x1, themeVars.space.x4),
});

export const noBorderClass = style({
  borderBottom: 'none !important',
});

export const itemSublabelClass = style({
  color: themeVars.colors.neutrals.black100,
  marginTop: themeVars.space.x2,
  fontWeight: themeVars.font.weight.regular,
});
